/*
Copyright © 2021 EPAM Systems, Inc. All Rights Reserved.
All information contained herein is, and remains the property of EPAM Systems, Inc.
and/or its suppliers and is protected by international intellectual property law.
Dissemination of this information or reproduction of this material is strictly
forbidden, unless prior written permission is obtained from EPAM Systems, Inc
*/
import React, { useEffect, useState } from 'react';
// import MaskedInput from 'react-text-mask';
import { IMaskInput as MaskedInput } from 'react-imask';

const input = require('b_')
    .with('input');

export const FormMaskedInput = ({
    id,
    required,
    disabled,
    error,
    mod,
    name,
    value,
    onChange,
    onBlur,
    mask,
    dispatch,
}) => {
    const [ val, setVal ] = useState(value);
    useEffect(() => setVal(value), [value]);
    return (
        <MaskedInput
            id={id}
            required={required}
            disabled={disabled}
            className={input({ error: !!error, ...mod })}
            name={name}
            value={val}
            title=""
            onChange={onChange}
            onBlur={onBlur}
            mask={mask}
            spellCheck={false}
            showMask
            dispatch={dispatch}
            guide
            lazy={false}
            onAccept={(v) => {
                setVal(v);
                onChange && onChange({ target: { value: v } });
            }}
        />
    );
};
